import type { EventTracking, TrackingActionWithId, State } from '../types';

/** @type {ActionType} */
export const pbr_modal_opened = 'pbr_modal_opened';

/** @type {ActionType} */
export const pbr_modal_closed = 'pbr_modal_closed';

function modalToggled(action: TrackingActionWithId, state: State): Object {
  return { id: action.payload.id };
}

// Make sure you cast this before you export it in your duckling.

const tracking: EventTracking = {};
tracking[pbr_modal_opened] = modalToggled;
tracking[pbr_modal_closed] = modalToggled;

export default tracking;
